module.exports = __webpack_public_path__ + "img/linkedin.4d2e8117.svg";